var map = {
	"./AIGC.svg": "oP3n",
	"./default.svg": "RzwZ",
	"./sq.svg": "F50x",
	"./业务管理.svg": "Cb0R",
	"./主管机关.svg": "kzH/",
	"./人事管理.svg": "iUo+",
	"./代办合同.svg": "/ZQv",
	"./任务派遣-.svg": "3FJ8",
	"./借款审批.svg": "Spr1",
	"./借款申请.svg": "7hOo",
	"./充值流水.svg": "j2qz",
	"./公司管理.svg": "n/im",
	"./出差审批.svg": "Wo+E",
	"./发起合同.svg": "Ccsh",
	"./合同列表.svg": "nTTO",
	"./合同收款.svg": "rxYM",
	"./合同管理.svg": "458n",
	"./员工列表.svg": "oB2Y",
	"./外出审批.svg": "kyv+",
	"./客户管理.svg": "jBOe",
	"./差旅报销审批.svg": "xwnW",
	"./差旅报销申请.svg": "Kuy1",
	"./平台费率.svg": "+SlJ",
	"./我的合同.svg": "JzSB",
	"./收入统计.svg": "3LFk",
	"./收款认领.svg": "xbkU",
	"./权限管理.svg": "X3Vr",
	"./标准化证明.svg": "D219",
	"./案卷管理-.svg": "A+Sv",
	"./消耗流水.svg": "I5J7",
	"./统计看板.svg": "11Sr",
	"./职位管理.svg": "MEe6",
	"./菜单管理.svg": "S5o8",
	"./行政管理.svg": "fEtG",
	"./角色管理.svg": "A2MR",
	"./评审员列表.svg": "hqc6",
	"./评审员结算单.svg": "4L2p",
	"./请假审批.svg": "kgNw",
	"./财务.svg": "O0Mw",
	"./账号管理.svg": "wQcT",
	"./费用报销审批.svg": "loZV",
	"./费用报销申请.svg": "qa8k",
	"./通知公告.svg": "5AqT",
	"./部门管理.svg": "L1fT",
	"./项目收款.svg": "J/X8",
	"./预付款审批.svg": "pPQH",
	"./预付款申请.svg": "iIQ0",
	"./首页.svg": "LHq3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 166